module.exports = __webpack_public_path__ + "img/Bitoque.c4e2bd14.png";